import Service from '../Service'
class UserService extends Service {
  constructor() {
    super()
    this.resource = 'users'
  }

  createRequestUrl(query) {
    let requestUrl = `${this.resource}?`

    if(query)
      query = this.encodeQueryValues(query);

    if (query.codigo)
      requestUrl += this.hasParameter(requestUrl)
        ? `&CODIGO=${query.codigo}`
        : `CODIGO=${query.codigo}`

    if (query.documento)
      requestUrl += this.hasParameter(requestUrl)
        ? `&CPF=${query.documento}`
        : `CPF=${query.documento}`

    if (query.nome)
      requestUrl += this.hasParameter(requestUrl)
        ? `&NOME=${query.nome}`
        : `NOME=${query.nome}`

    if (query.todos)
      requestUrl += this.hasParameter(requestUrl)
        ? `&TODOS=${query.todos}`
        : `TODOS=${query.todos}`
    else
      requestUrl += this.hasParameter(requestUrl)
        ? `&page=${query.page}`
        : `page=${query.page}`

    return requestUrl
  }

  async getUsers(query) {
    let requestUrl = this.createRequestUrl(query)

    return await this.getAPI(requestUrl)
  }

  async getUser(id) {
    let requestUrl = `${this.resource}/${encodeURIComponent(id)}`
    return await this.getAPI(requestUrl)
  }
}

export default new UserService()
